module.exports = ['$scope', '$rootScope', '$phoneModal', 'User', '$translate', '$utils', 'sharedMailboxService', 'mailFolderService',
  function ($scope, $rootScope, $phoneModal, User, $translate, $utils, sharedMailboxService, mailFolderService) {
    $scope.listSharedAccessMailbox = function (action = '') {
      $scope.isLoading = true
      /** 获取共享给当前用户的邮箱 */
      sharedMailboxService.listSharedAccessMailbox({ showHidden: true }).then(data => {
        if (data.code === 'S_OK' && data.var) {
          $scope.sharedMailboxList = data.var || []
          if (!$scope.sharedMailboxList.length) {
            $utils.$notify.set({ message: $translate.instant('SETTING.SHARED_MAILBOX.NO_SHARED_MAILBOX') })
            return
          }
          User.updateMailboxAccounts({visibleMailboxList: $scope.sharedMailboxList})
          $scope.sharedMailboxList.forEach(i => {
            i['visible'] = !i.hidden
            const { rw, send } = i
            if (!rw && !send) i['_perm'] = $translate.instant('SETTING.SHARED_MAILBOX.READ_ONLY')
            else if (rw && send) i['_perm'] = $translate.instant('SETTING.SHARED_MAILBOX.AGENT') + $translate.instant('OP.SEND')
            else if (!rw && send) i['_perm'] = $translate.instant('SETTING.SHARED_MAILBOX.DELEGATE') + $translate.instant('OP.SEND')
          })
          $scope.isLoading = false
          action !== 'refresh' && showSharedMailboxList()
        }
      }, err => {
        console.error(err)
      })
    }
    // 设置共享邮箱是否在“我的邮箱”中显示
    $scope.setSharedAccessMboxVisible = function (mailbox) {
      $scope.isLoading = true
      const { email, visible } = mailbox
      sharedMailboxService.setSharedAccessMboxVisible({ email, visible }).then(data => {
        if (data.code === 'S_OK') {
          $utils.$notify.set({ message: $translate.instant('SETTING.SHARED_MAILBOX.UPDATE_SUCCEEDED') })
          mailbox.hidden = !visible
          User.updateMailboxAccounts({visibleMailboxList: $scope.sharedMailboxList})
          handleSelectedMailboxHidden(mailbox)
          $scope.isLoading = false
        }
      }, _ => {
        $utils.$notify.set({ message: $translate.instant('SETTING.SHARED_MAILBOX.UPDATE_FAILED') })
        mailbox.visible = !visible
      })
    }
    // 处理选中账号被设置隐藏
    function handleSelectedMailboxHidden(mailbox) {
      const { email, visible } = mailbox
      const mailboxAccounts = User.getMailboxAccounts()
      const selectedMailbox = mailboxAccounts.selectedAccount
      if (selectedMailbox && selectedMailbox.email === email && !visible) {
        User.updateMailboxAccounts({selectedAccount: mailboxAccounts.mainAccount})
        console.log(mailboxAccounts)
        mailFolderService.clearFolders()
        $rootScope.$emit('refresh-draft')
      }
    }

    /** 显示“共享给我的邮箱”的列表 */
    function showSharedMailboxList() {
      $scope.mailboxModal = $phoneModal.fromTemplate(require('views/setting/sharedMailbox/sharedMailboxList.html'), {
        scope: $scope,
        animation: 'slide-in-right'
      })
      $scope.mailboxModal.show()

      $scope.closeModal = () => $scope.mailboxModal.remove()
    }
  }]



// WEBPACK FOOTER //
// ./src/js/setting/sharedMailbox/sharedMailboxCtrl.js